import cotaRioImg from '../assets/projects/cota-rio.png';
import movieExplorerImg from '../assets/projects/movie-explorer.png';
import cidadãoAppImg from '../assets/projects/cidadao.png';
import agenteImg from '../assets/projects/agente.png';

export interface Project {
  id: number;
  title: string;
  description: string;
  image: string;
  link: string;
  infoLink?: string;
  appleLink?: string;
  technologies: string[];
  details: string;
}

export function getProjects(language: string) {
  return [
    {
      id: 1,
      title: language === "pt" ? "Aplicativo Cota Rio." : "Application Cota Rio.",
      description: language === "pt" ? "Aplicativo Mobile para os Maritimos." : "Mobile Application for Seafarers.",
      image: cotaRioImg,
      link: "https://play.google.com/store/apps/details?id=com.defesa_civil.cotarioapp",
      appleLink: "https://apps.apple.com/br/app/cota-rio/id6741776232",
      infoLink: "https://www.defesacivil.am.gov.br/defesa-civil-do-amazonas-apresenta-o-aplicativo-cota-rio/",
      technologies: ["React Native", "Expo"],
      details: language === "pt" ? "O aplicativo Cota Rio é uma solução inovadora para monitoramento de níveis de água em rios, ajudando marítimos a navegar com segurança." : "The Cota Rio app is an innovative solution for monitoring water levels in rivers, helping seafarers navigate safely."
    },
    {
      id: 2,
      title: language === "pt" ? "Explorador de Filmes." : "Movie Explorer.",
      description: language === "pt" ? "Aplicativo de filmes populares, busca e favoritos." : "Android app for popular movies, search and favorites.",
      image: movieExplorerImg,
      link: "https://github.com/larads/MovieExplorer",
      technologies: ["Kotlin", "MVVM", "Clean Architecture", "Retrofit", "Room", "Hilt"],
      details: language === "pt"
        ? "Aplicativo Android modular com Clean Architecture: listagem de filmes populares via API TMDb, busca com debounce, detalhes com trailer e favoritos persistidos com Room."
        : "Modular Android app with Clean Architecture: popular movies listing via TMDb API, debounced search, details with trailer and favorites persisted with Room."
    },
    {
      id: 3,
      title: language === "pt" ? "Aplicativo Cidadão." : "Cidadão App.",
      description: language === "pt" ? "Aplicativo Mobile para os Cidadãos." : "Mobile Application for Citizens.",
      image: cidadãoAppImg,
      link: "https://play.google.com/store/apps/details?id=com.anonymous.cidadaoapp&hl=pt_BR&pli=1",
      appleLink: "https://apps.apple.com/br/app/cidad%C3%A3o-defesa-civil-am/id6504114750",
      technologies: ["React Native", "Expo"],
      details: language === "pt" ? "O aplicativo Cidadão é uma ferramenta essencial para quem deseja se manter informado sobre as condições meteorológicas e geológicas em tempo real. Com uma interface intuitiva e de fácil utilização, o aplicativo fornece alertas diários sobre chuvas, previsões meteorológicas, dados geológicos e níveis dos rios. Com o Cidadão Defesa Civil, você pode cadastrar e acompanhar ocorrências em tempo real, garantindo que você e sua família estejam sempre preparados para qualquer situação. Além disso, o aplicativo oferece recursos adicionais, como mapas interativos, para que você possa acessar as informações mais relevantes de forma rápida e fácil." : "The Cidadão app is an essential tool for those who want to stay informed about meteorological and geological conditions in real-time. With an intuitive interface and easy-to-use design, the app provides daily alerts about rainfall, weather forecasts, geological data, and river levels. With the Cidadão Civil Defense, you can register and track incidents in real-time, ensuring you and your family are always prepared for any situation. Additionally, the app offers additional features, such as interactive maps, so you can quickly access the most relevant information."
    },
    // {
    //   id: 3,
    //   title: language === "pt" ? "Android Diagnostic Tool." : "Android Diagnostic Tool.",
    //   description: language === "pt" ? "Ferramenta Android para diagnóstico do dispositivo." : "Android tool for device diagnostics.",
    //   image: diagnosticToolImg,
    //   link: "https://github.com/larads/DiagnosticTool",
    //   technologies: ["Kotlin", "Android"],
    //   details: language === "pt"
    //     ? "Aplicativo Android para coletar e exibir informações de diagnóstico do dispositivo, auxiliando na análise de hardware, sistema e ambiente de execução."
    //     : "Android application to collect and display device diagnostic information, helping analyze hardware, system and runtime environment."
    // },
    // {
    //   id: 4,
    //   title: language === "pt" ? "Sistema Point.pro." : "System Point.pro.",
    //   description: language === "pt" ? "Gerenciamento de batimento de ponto para o RH" : "point.pro for RH",
    //   image: pointProSystemImg,
    //   link: "https://github.com/larads/task-manager-pro",
    //   infoLink: "https://github.com/larads/point.pro-",
    //   technologies: ["React Native", "Expo", "Tailwind CSS"],
    //   details: language === "pt" ? "O Sistema point.pro e uma solução de gerenciamento de batimento de pontos para empresas que desejam gerenciar o ponto do seus funcionários." : "The point.pro app is a solution for companies to manage their employees' attendance."
    // },
    {
      id: 5,
      title: language === "pt" ? "Aplicativo Agente Defesa Civil." : "Application Agente Defesa Civil.",
      description: language === "pt" ? "Aplicativo Mobile para Agentes da Defesa Civil" : "Mobile Application for Civil Defense Agents",
      image: agenteImg,
      link: "https://play.google.com/store/apps/details?id=com.defesa_civil.agenteappworkflow&hl=pt_BR",
      technologies: ["React Native", "Expo"],
      infoLink: "https://www.defesacivil.am.gov.br/defesa-civil-do-amazonas-realiza-primeiro-teste-com-aplicativo-agente-na-comunidade-do-catalao-iranduba/",
      details: language === "pt" ? "O aplicativo Agente Defesa Civil é uma solução para cadastro e gerenciamento de agentes da Defesa Civil do Amazonas, permitindo login e registro de novos membros da equipe." : "The Agente Defesa Civil app is a solution for registration and management of Civil Defense agents in Amazonas, allowing login and registration of new team members."
    },
  ]
}